export const X_VUP_ORIGIN_HEADER_NAME = 'X-VUP-ORIGIN';
export const X_VUP_ORIGIN_PUBLISHER = 'publisher';
export const X_VUP_ORIGIN_IFRAME = 'iframe';

export function getPublisherOriginRequestOptions() {
  return {
    headers: {[X_VUP_ORIGIN_HEADER_NAME]: X_VUP_ORIGIN_PUBLISHER}
  };
}
